import * as React from 'react';

function SvgChangeArea(props: React.SVGProps<SVGSVGElement>): any {
    return (
        <svg width="1em" height="1em" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M14.625 5.25L11.5 9H17.75L14.625 5.25ZM20.25 5.25L23.375 9L26.5 5.25H20.25ZM10.25 11.5C9.91849 11.5 9.60057 11.6317 9.36615 11.8662C9.13174 12.1006 9.00003 12.4185 9 12.75V31.5C9.00003 31.8315 9.13174 32.1494 9.36615 32.3838C9.60057 32.6183 9.91849 32.75 10.25 32.75H27.75C28.0815 32.75 28.3994 32.6183 28.6338 32.3838C28.8683 32.1494 29 31.8315 29 31.5V12.75C29 12.4185 28.8683 12.1006 28.6338 11.8662C28.3994 11.6317 28.0815 11.5 27.75 11.5H10.25ZM11.5 14H17.75V30.25H11.5V14ZM20.25 14H26.5V30.25H20.25V14Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgChangeArea;
